export const DEFAULT_TOOL_TIP_DELAY = process.env.NODE_ENV === 'test' ? 10 : 500;
export const tooltipPositions = ['top', 'left', 'right', 'bottom'] as const;
import React from 'react';

export type TooltipPosition = (typeof tooltipPositions)[number];

export interface TooltipProps {
  position?: TooltipPosition;
  children?: React.JSX.Element | string;
  text: React.JSX.Element | string;
  delay?: number;
}

export interface TooltipComponentProps {
  /** text to display on tooltip */
  tooltip?: string;
  /** number of milliseconds to wait before showing a tooltip on-hover */
  tooltipDelay?: number;
  /** one of four possible tooltip positions */
  tooltipPlacement?: TooltipPosition;
  /** true if the provided tooltip text should be rendered as HTML */
  isHtmlTooltip?: boolean;
  /** optional testId applied to the tooltip - useful for testing */
  tooltipTestId?: string;
}
